<template>
  <div>
    <v-layout justify-center>
      <v-flex xs12 sm6 md5 lg4>
        <v-form ref="form">
          <v-card @keyup.enter="signIn">
            <v-card-title>
              <div>
                <h3 class="headline mb-0">Please sign in...</h3>
              </div>
            </v-card-title>
            <v-card-text>
              <v-text-field label="Username" id="username" name="username" type="text" v-model.trim="username" :rules="[required]" :disabled="isDisabled"></v-text-field>
              <v-text-field label="Password" id="password" name="password" type="password" v-model.trim="password" :rules="[required]" :disabled="isDisabled"></v-text-field>
              <v-alert dismissible outlined v-model="authenticationIncorrect" type="error" transition="fade-transition">Invalid Username or Password.</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="signIn" :loading="isDisabled" :disabled="isDisabled">Sign In</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import authentication from '@/services/Authentication';
import validators from '@/utility/validators';

@Component
export default class SignIn extends Vue {
  authenticationIncorrect = false;
  isDisabled = false;
  username = process.env.VUE_APP_DEFAULT_USERNAME;
  password = process.env.VUE_APP_DEFAULT_PASSWORD;
  required = validators.required;

  signIn() {
    this.authenticationIncorrect = false;
    if (this.$refs.form.validate()) {
      this.isDisabled = true;
      authentication.authenticate(this.username, this.password).then(() => {
        this.$emit('signedIn');
        this.isDisabled = false;
      }).catch(() => {
        this.authenticationIncorrect = true;
        this.isDisabled = false;
      });
    }
  }
}
</script>
